import type { ProductListResponseType } from "@sellar-io/api-v2/types";
import { InputSearch, InputSearchDropdown } from "@sellar-io/components";
import { InputHTMLAttributes, useState } from "react";
import { useDebounce } from "use-debounce";
import {
  ItemTypeImage,
  SpinnerLegacy,
  StockIndicator,
} from "../../../components";
import { InfiniteList } from "../../../components/infiniteLoading/InfiniteList";
import { ListElement } from "../../../components/list/ListElement";
import { useProductList } from "../../../hooks/api/v2/product/useProductList";

export const ProductSearchInput = (
  props: Omit<InputHTMLAttributes<HTMLInputElement>, "onChange"> & {
    onChange: (product?: ProductListResponseType[number]) => void;
  },
) => {
  const [searchValue, setSearchValue] = useState("");
  const [debouncedSearchValue] = useDebounce(searchValue, 500);

  const products = useProductList(
    {
      query: [
        {
          type: "ParentId",
          modifier: "NOT_NULL",
        },
        {
          type: "active",
          modifier: "EQUALS",
          value: true,
        },
        {
          type: "showAllProducts",
          modifier: "EQUALS",
          value: true,
        },
      ],
      search: debouncedSearchValue,
      limit: 5,
    },
    {
      enabled: !!searchValue,
    },
  );

  return (
    <InputSearch
      {...props}
      value={searchValue}
      onChange={(e) => setSearchValue(e.target.value)}
    >
      <div className={"max-h-72"}>
        <InputSearchDropdown
          isLoading={products.isLoading}
          hasResults={Boolean(products.data?.pages[0]?.length)}
          loadingFallback={
            products.fetchStatus === "idle" ? null : <SpinnerLegacy />
          }
        >
          {({ close }) => (
            <InfiniteList query={products}>
              {products.data?.pages.map((page) =>
                page.map((product, index) => (
                  <ListElement
                    key={index}
                    onClick={() => {
                      props.onChange(product);
                      close();
                    }}
                  >
                    <ItemTypeImage product={product} />
                    {product.name}
                    <StockIndicator
                      stock={product.availableStock}
                      type="short"
                    />
                  </ListElement>
                )),
              )}
            </InfiniteList>
          )}
        </InputSearchDropdown>
      </div>
    </InputSearch>
  );
};
